export const DEFAULT_EASE = [0.4, 0, 0, 1];
export const DEFAULT_DURATION = 1;
export const DEFAULT_STAGGER = 0.1;
export const DEFAULT_TRANSITION = { ease: DEFAULT_EASE, duration: DEFAULT_DURATION };
